const downloadFile = (dataFile, nameFile, typeFile) => {
  let blob = new Blob([dataFile], { type: typeFile })
  let link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = nameFile
  link.click()
}
export default downloadFile
